import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import { rounder } from "MODULES/shared/components/Forms/NumberInput/NumberInput";
import FormField from "./FormField";

export function FormInput({
  type = "text",
  className = "",
  name,
  label,
  disabled = false,
  isRequired = false,
  parse,
  ...inputProps
}) {
  return (
    <Field name={name}>
      {({ field, meta, ...childProps }) => {
        let onBlur;
        if (type === "number" && inputProps.step === "0.01") {
          onBlur = ev => {
            ev.target.value = rounder(ev.target.value);
            field.onBlur(ev);
          };
        } else {
          onBlur = field.onBlur;
        }

        // Handle parsing on change
        const handleChange = ev => {
          const parsedValue = parse ? parse(ev.target.value) : ev.target.value;
          // Create a new event object with the same properties as the original event
          const newEvent = {
            ...ev,
            target: {
              ...ev.target,
              value: parsedValue,
              name // Ensure the name attribute is included
            }
          };
          field.onChange(newEvent); // Pass the new event object to field.onChange
        };

        return (
          <FormField
            {...childProps}
            field={field}
            label={label}
            required={isRequired}
          >
            <input
              type={type}
              onChange={handleChange}
              onBlur={onBlur}
              name={name}
              disabled={disabled}
              value={
                field.value === meta.initialValue &&
                type === "number" &&
                inputProps.step === "0.01"
                  ? rounder(field.value)
                  : field.value
              }
              className={`form-control ${className}`}
              {...inputProps}
            />
          </FormField>
        );
      }}
    </Field>
  );
}

export default FormInput;

FormInput.propTypes = {
  parse: PropTypes.func,
  format: PropTypes.func,
  input: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  inputProps: PropTypes.shape({
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormikFormInput/FormInput.jsx